import { ICloudStoargeUploader } from "@home-health-notify/domain";
import axios, { AxiosProgressEvent } from "axios";

export const uploadToCloudStorage: ICloudStoargeUploader = async (
  presignedUrl,
  key,
  file,
  headers,
  onUploadProgress,
) => {
  const config = {
    headers,
    onUploadProgress: (progressEvent: AxiosProgressEvent) => {
      if (onUploadProgress && progressEvent.total) {
        onUploadProgress({
          key,
          isUploaded: progressEvent.loaded === progressEvent.total,
          remainingSize: progressEvent.total - progressEvent.loaded,
          uploadedSize: progressEvent.loaded,
        });
      }
    },
  };
  try {
    const response = await axios.put(presignedUrl, file, config);
    return {
      status: response.status,
      body: response.data,
    };
  } catch (error: any) {
    throw error;
  }
};
